import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = {
    success: (message) => {
        toast.success(message, {
            position: 'top-right',
            autoClose: 3000,
        });
    },
    warning: (message) => {
        toast.warning(message, {
            position: 'top-right',
            autoClose: 3000,
        });
    },
    error: (message) => {
        toast.error(message, {
            position: 'top-right',
            autoClose: 3000,
        });
    },
};

const ToastProvider = () => {
    return <ToastContainer />;
};

export { Toast, ToastProvider };
